import React, { useContext, useState } from "react";
import "./Login.scss";
import loginGif from "../../assets/gif&videos/Login_Gif.m4v";
import Input from "../../component/inputs/Input";
import { Link, useNavigate } from "react-router-dom";
import { sellerApi } from "../../utils/Api";
import UseForm from "../../UseForm";
import ValidateLogin from "../../validate/ValidateLogin";
import { UserContext } from "../../Context";
import Loader from "../Loader/Loader";
import ReactPlayer from "react-player";
import logo from "../../assets/header/logos/matte_logo.png";
import bcrypt from "bcryptjs";

function Login() {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { fetchUser } = useContext(UserContext);

  const login = async () => {
    try {
      setLoader(true);

      const response = await sellerApi.post("api/seller/login", values);

      if (response.status === 200) {
        await fetchUser();

        navigate("/dashboard");
        // window.location.reload();

        localStorage.setItem("auth", true);
      }
    } catch (error) {
      if (error.response?.status === 400) {
        setErrors({
          email: "email is incorrect",
        });
      }
      if (error.response?.data?.message === "Incorrect email or password") {
        setErrors({
          password: "password is incorrect",
        });
      }
    } finally {
      setLoader(false);
    }
  };

  const formObj = { email: "", password: "" };

  const { handleChange, handleSubmit, values, errors, setErrors } = UseForm(
    formObj,
    ValidateLogin,
    login
  );

  return (
    <>
      {loader && <Loader />}
      <div className="login_page parent">
        <div className="login_page_cont cont">
          <div className="left_login">
            <h1>Welcome Jungleboosh Seller.</h1>
            <div class="login_gif">
              <ReactPlayer
                url={loginGif}
                height="100%"
                width="100%"
                className="react-video"
                playing={true} // Corrected from autoplay to playing
                loop={true}
                controls={false}
                muted={true} // Optionally mute if you don't need audio
              />
            </div>
            <Link to="/register" class="btn">
              Register Your Business
            </Link>
          </div>
          <div className="right_login">
            <form onSubmit={handleSubmit}>
              <img src={logo} alt="" />
              <div className="form-row">
                <Input
                  label="Email"
                  name="email"
                  onChange={handleChange}
                  value={values.email}
                />
                {errors.email && (
                  <small className="text-warning">{errors.email}</small>
                )}
              </div>
              <div className="form-row">
                <Input
                  label="Password"
                  name="password"
                  onChange={handleChange}
                  value={values.password}
                  password={true}
                />
                {errors.password && (
                  <small className="text-warning">{errors.password}</small>
                )}
              </div>
              <div className="question_tags">
                <Link className="link" to="/forgotpassword">
                  Forgot Password ?
                </Link>
                <Link to="/register" className="link link2">
                  Register Our Business
                </Link>
              </div>
              <input className="btn login_btn" value="Log in" type="submit" />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
